import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { useCallback, useEffect } from 'react'

import { Pin } from '#/components/Maps/Markers/types'

interface PinMarkerProps {
  map: google.maps.Map | null
  marker: Pin
}

export function PinMarker({ map, marker }: PinMarkerProps) {
  const { lat, lng, setLat, setLng } = marker
  const hasPosition = lat && lng

  /**
   * Manipula o evento de duplo clique no mapa, atualizando a posição do marcador.
   */
  const handleDoubleClick = useCallback(
    (event: google.maps.MapMouseEvent) => {
      if (map && event.latLng) {
        setLng(event.latLng.lng())
        setLat(event.latLng.lat())
      }
    },
    [map, setLat, setLng],
  )

  useEffect(() => {
    if (map) {
      // Centraliza o mapa na posição do marcador
      if (hasPosition) {
        map.setCenter(new window.google.maps.LatLng(lat, lng))
      }
      map.addListener('dblclick', handleDoubleClick)
    }

    // Limpa listeners ao desmontar ou atualizar dependências
    return () => {
      if (map) {
        window.google.maps.event.clearListeners(map, 'dblclick')
      }
    }
  }, [map, lat, lng, handleDoubleClick])

  return hasPosition && <AdvancedMarker position={{ lat, lng }} />
}
